import { Injectable } from '@angular/core';

import { toFixed } from '../../../../core/services/utils/numbers';
import { AtividadeChecklistItem } from '../atividade-checklist-item';

@Injectable({
    providedIn: 'root'
})
export class AtividadeChecklistItemCalculoService {

    /** Calcula a quantidade de itens concluídos no checklist */
    calcularQuantidadeChecklistItensConcluidos(entities: AtividadeChecklistItem[]): number {
        if (!entities) {
            return 0;
        }

        let quantidadeItensConcluidos = 0;
        entities.forEach(entity => {
            if (entity.concluido) {
                quantidadeItensConcluidos++;
            }
        });

        return quantidadeItensConcluidos;
    }

    /** Calcula o percentual de itens concluídos no checklist */
    calcularPercQuantidadeChecklistItensConcluidos(quantidadeChecklistItensConcluidos: number, quantidadeChecklistItens: number): number {
        quantidadeChecklistItensConcluidos = quantidadeChecklistItensConcluidos && !isNaN(quantidadeChecklistItensConcluidos) ? Number(quantidadeChecklistItensConcluidos) : 0;
        quantidadeChecklistItens = quantidadeChecklistItens && !isNaN(quantidadeChecklistItens) ? Number(quantidadeChecklistItens) : 0;
        if (quantidadeChecklistItens <= 0) {
            return 0;
        }

        const percQuantidadeChecklistItensConcluidos = (quantidadeChecklistItensConcluidos / quantidadeChecklistItens) * 100;
        return toFixed(percQuantidadeChecklistItensConcluidos, 2);
    }
}
